// extracted by mini-css-extract-plugin
export default {"loaderWrapper":"OSpinner_loaderWrapper__KIUFa","spin-animation":"OSpinner_spin-animation__LIwSu"};